$( document ).ready(function() {

    let datosTiempo="";
    let indice=2;
    let tipo="dias";

    function muestraModal(texto) {
        const modal = document.getElementById("myModal");
        const span = document.getElementsByClassName("close")[0];
        const textomodal = document.getElementsByClassName("texto_modal")[0];
        textomodal.innerHTML = textomodal.getAttribute("data-".concat(texto));
        modal.style.display = "block";
        span.onclick = function cierraAlClicar() {
            modal.style.display = "none";
        };
        window.onclick = function cierraAlClicarWindows(event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        };
    }


    function muestraModalCompartir(texto) {
        const modal = document.getElementById("myModalCompartir");
        const textomodal = document.getElementsByClassName("contenido_compartir")[0];
        textomodal.innerHTML = texto;
        modal.style.display = "block";
        $('.close').on('click',function(){
            modal.style.display = "none";
        });
        window.onclick = function cierraAlClicarWindows(event) {
            if (event.target === modal) {
                modal.style.display = "none";
            }
        };
    }


    function extraeIcono(nombre){
        let resultado="";
        switch (nombre) {
            case 'rain': // chuva
                resultado = '05-Rainy.svg'
                break
            case 'partly-cloudy-day': // parcialmente nublado dia
                resultado= '02-Sun-Cloudy.svg'
                break
            case 'cloudy': // nublado
                resultado= '04-Cloudy.svg'
                break
            case 'clear-day': // limpo
                resultado = '01-Sun.svg'
                break
            case 'snow': // neve
                resultado = '06-Snow.svg'
                break
            case 'partly-cloudy-night':
                resultado= '03-Weather-Cloud.svg'
                break
            default: // limpo
                resultado = '01-Sun.svg'
                break
        }
        return resultado;
    }

    function extraeLuna(nombre){
        let resultado="";
        if(nombre===0 || nombre===1){
            resultado="nueva.svg";
        }else if(nombre > 0 && nombre<0.5){
            resultado="creciente.svg";
        }else if(nombre===0.5){
            resultado="llena.svg";
        }else if(nombre > 0.5 && nombre<1){
            resultado="menguante.svg";
        }
        return resultado;
    }

    function muestraDiaActual($indice) {

        const fecha = new Date(datosTiempo.days[$indice].datetime);
        const mes = fecha.getMonth() + 1;
        const mesLenguaje = lang.meses[parseInt(mes, 10)];
        const imagenLuna = extraeLuna(datosTiempo.days[$indice].moonphase);
        const iconoGrande = `${extraeIcono(datosTiempo.days[$indice].icon)}`;
        const hora= datosTiempo.days[$indice].sunset.split(':');

        $('#fecha_titulo').html(`${fecha.getDate()} ${mesLenguaje} ${fecha.getFullYear()}`);
        $('#ciudad_titulo').html($('#ciudades').find(":selected").text());
        $('.temperatura_actual').html(`${datosTiempo.days[$indice].temp}&#176;`);
        $('.datos_min_actual').html(`${datosTiempo.days[$indice].tempmin}&#176;`);
        $('.datos_max_actual').html(`${datosTiempo.days[$indice].tempmax}&#176;`);
        $('.resumen_actual').html(`${datosTiempo.days[$indice].conditions}`);
        $('#dato_humedad').html(`${datosTiempo.days[$indice].humidity}%`);
        $('#dato_prob_lluvia').html(`${datosTiempo.days[$indice].precipprob}%`);
        $('#dato_vol').html(`${datosTiempo.days[$indice].precip}`);
        $('#dato_viento').html(`${datosTiempo.days[$indice].windspeed}`);
        $('#dato_atardecer').html(`${hora[0]}:${hora[1]}`);
        $('#logo_basico_img').attr("src", `images/tiempo/${iconoGrande}`);
        $('#dato_fase_lunar img').attr("src", `images/iconos_detalles/${imagenLuna}`);
    }

    function muestraDatosDias($indice){
        $('.resumen_de_dias ul').html('');

        destruyeCarrusel();
        if(typeof datosTiempo.days[2].hours === 'undefined') {
            tipo="dias";
            $('.titulo_otros_dias').html(lang.otros_dias);
            datosTiempo.days.forEach(function(item,index) {
                const dt = new Date(item.datetime);
                const iconoGrande=`${extraeIcono(item.icon)}`;
                $('#logo_basico_img').attr("src",`images/tiempo/${iconoGrande}`);
                let html='<li class="dias ';
                if(index === $indice){
                    html +=' selected ';
                }
                html +=`"><div class="bloque_por_horas_dias"><div class="dia_de_la_semana" data-indicedia="${index}">${lang.diaSemana[dt.getDay()].corto} ${dt.getDate()}</div>`;
                html+=`<div class="clima_dia_de_la_semana"><img src="images/tiempo/${iconoGrande}" class="img_fluid"></div>`;
                html+=`<div class="grados_dia_de_la_semana">${item.temp}&#176;</div></div></li>`;
                $('.resumen_de_dias ul').append(html);
                $('.dia_de_la_semana').on('click',function(){
                    muestraDiaActual($(this).data('indicedia'));
                    $('.resumen_de_dias ul li').removeClass('selected');
                    muestraDatosDias($(this).data('indicedia'));
                })
            });
        }else{

            tipo="horas";
            $('.titulo_otros_dias').html(lang.por_horas);
            datosTiempo.days[2].hours.forEach(function(item,index) {
                const hora= item.datetime.split(':');
                const iconoGrande=`${extraeIcono(item.icon)}`;
                $('#logo_basico_img').attr("src",`images/tiempo/${iconoGrande}`);
                let html='<li class="horas ';
                html +=`" data-indicehoras="${index}"><div class="bloque_por_horas_dias"><div class="dia_de_la_semana" data-indicedia="${index}">${hora[0]}h</div>`;
                html+=`<div class="clima_dia_de_la_semana"><img src="images/tiempo/${iconoGrande}" class="img_fluid"></div>`;
                html+=`<div class="grados_dia_de_la_semana">${item.temp}&#176;</div></div></li>`;
                $('.resumen_de_dias ul').append(html);
                $('.dia_de_la_semana').on('click',function(){
                    muestraDiaActual($(this).data('indicedia'));
                    $('.resumen_de_dias ul li').removeClass('selected');
                    muestraDatosDias($(this).data('indicedia'));
                })
            });
            generaCarrusel();
        }
    }


     function getForecast() {

         $('.resumen_de_dias ul').html('');
        const key = 'Y566UFWYRMQW44YWDUKYNEP7F';
        const address = $('#ciudades').find(":selected").val()
        const lang = $('#lang').val();
        const fecha = $('#fecha').val();
        const d = new Date(fecha);
        d.setDate(d.getDate() + 2);
        const fechaFinal=`${d.getFullYear()  }-${  d.getMonth()+1  }-${  d.getDate()}`
         d.setDate(d.getDate() - 4);
         const fechaInicial=`${d.getFullYear()  }-${  d.getMonth()+1  }-${  d.getDate()}`

        let url = `https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/${address.charAt(0).toUpperCase()}${address.slice(1)}`;
        url+=`/${fechaInicial}/${fechaFinal}?unitGroup=metric&key=${key}&lang=${lang}`;

        if(address==="" || fecha ==="" ){
            muestraModal('requeridos');
        }else {
            $.ajax({
                method: "GET",
                url,
            }).done(function (msg) {
                datosTiempo=msg;
                console.log(datosTiempo.days[0].temp);
                if(datosTiempo.days[0].temp === null){
                    muestraModal('sindatos');
                }else{
                    muestraDiaActual(indice);
                    muestraDatosDias(indice);
                    $('#pagina_uno').removeClass('active');
                    $('#pagina_dos').addClass('active');
                }
            }).fail(function () {
                muestraModal('sindatos');
            });
        }
    }

    function traduceFecha(d){
        let day = d.getDate();
        let month = d.getMonth() + 1;
        const year = d.getFullYear();
        if (day < 10) {
            day = `0${  day}`;
        }
        if (month < 10) {
            month = `0${  month}`;
        }

        const fechaFinal=`${year}-${month}-${day}`;
        return fechaFinal;
    }
        $('.navegacion_prev').on('click',function(){
            if(tipo==="dias"){
                indice -= 1;
                if (indice < 0) {
                    indice = 2;
                    const fecha = $('#fecha').val();
                    const d = new Date(fecha);
                    d.setDate(d.getDate() - 3);
                    $('#fecha').val(traduceFecha(d));
                    getForecast();
                } else {
                    muestraDiaActual(indice);
                    muestraDatosDias(indice);
                }
            }else{
                $(".resumen_de_dias ul").slick("slickPrev");
            }
        });

        $('.navegacion_next').on('click',function(){

            if(tipo==="dias") {
                indice += 1;
                if (indice > 4) {
                    indice = 2;
                    const fecha = $('#fecha').val();
                    const d = new Date(fecha);
                    d.setDate(d.getDate() + 3);
                    $('#fecha').val(traduceFecha(d));
                    getForecast();
                } else {
                    muestraDiaActual(indice);
                    muestraDatosDias(indice);
                }
            }else{
                $(".resumen_de_dias ul").slick("slickNext");
            }
        });



    function generaCarrusel(){
        $('.resumen_de_dias ul').slick({
            slidesToShow: 5,
            initialSlide:12,
            focusOnSelect: true,
            centerMode:true,
            centerPadding:0,
            prevArrow: $('.navegacion_prev'),
            nextArrow: $('.navegacion_next'),
        });

    }

    function destruyeCarrusel(){
        if ($('.resumen_de_dias ul').hasClass('slick-initialized')) {
            $('.resumen_de_dias ul').slick('destroy');
            $('.resumen_de_dias ul').html('');
        }
    }

    function generalUrl(){
        const fecha = $('#fecha').val();
        const lang = $('#idioma').val();
        const address = $('#ciudades').find(":selected").val();
        const ciudad = $('#ciudades').find(":selected").text();
        const pais = $('#paises').find(":selected").val();
        const url  = `https://weddingtools.net/weather/weather.php?lang=${(lang)}&fecha=${encodeURIComponent(fecha)}&address=${encodeURIComponent(address)}&ps=${(pais)}&pais=${(lang)}&ciudad=${encodeURIComponent(ciudad)}`;
        return (url);
    }

    function copyToClipboard(element) {
        const aux = document.createElement("input");
        aux.setAttribute("value", element);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        $('.copia_link').html(lang.enlace_copiado);
    }

    function saveAs(uri, filename) {
        const link = document.createElement('a');
        if (typeof link.download === 'string') {
            link.href = uri;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            window.open(uri);
        }
    }

    function capturaPantalla(){
        $('.atras').hide();
        $('.compartir').hide();
        $('.resumen_de_dias li.selected .bloque_por_horas_dias').css('background-color','transparent');
        $('.resumen_de_dias li.selected .bloque_por_horas_dias').css('color','#000000');
        $('.slick-current .bloque_por_horas_dias').css('background-color','transparent');
        $('.slick-current .bloque_por_horas_dias').css('color','#000000');
        html2canvas($("#pagina_dos")[0]).then((canvas) => {
                saveAs(canvas.toDataURL(), 'weather.png');
            });
        $('.atras').show();
        $('.compartir').show();
        $('.slick-current .bloque_por_horas_dias').css('background-color','#F76C6F');
        $('.slick-current .bloque_por_horas_dias').css('color','#ffffff');
        $('.resumen_de_dias li.selected .bloque_por_horas_dias').css('background-color','#F76C6F');
        $('.resumen_de_dias li.selected .bloque_por_horas_dias').css('color','#ffffff');
    }

    $('#enviar').on('click',function(){
        getForecast();
        modalFinal();
    })

    if($('#ejecutaAlIniciar').val()==='1'){
        getForecast();
    }



    $('#paises').select2({
        dropdownPosition:'below'
    });

    $('#ciudades').select2({
        minimumInputLength:3,
        dropdownPosition:'below',
        language: $('#idioma').val(),
        ajax: {
            url: './data/ajax.php',
            data($params){
                const valor=$('#paises').find(":selected").val();
                const $datos = {
                    search: $params.term,
                    pais: valor
                }
                return $datos;
            },
            dataType: 'json',
            processResults (data) {
                return {
                    results: data.results
                };
            }
        }
    })

    $(document).on('select2:opening', () => {
        const searchInput = $('.select2-container--open .select2-search__field').last().get(0);
        if (searchInput) {
            $(this).one('mouseup',()=>{
                setTimeout(()=>{
                    if ($(document.activeElement).closest('.select2').length) {
                        searchInput.focus();
                    }
                },0);
            });
        }
    });

 $(document).on('select2:open', () => {
        const searchInput = $('.select2-container--open .select2-search__field').last().get(0);
        if (searchInput) {
            $(this).one('mouseup',()=>{
                setTimeout(()=>{
                    if ($(document.activeElement).closest('.select2').length) {
                        searchInput.focus();
                    }
                },0);
            });
        }
    });

    $('.atras').on('click',function(){
        $('#pagina_dos').removeClass('active');
        $('#pagina_uno').addClass('active');
    })

    $('.compartir').on('click',function(){
        const url=generalUrl();
        let texto='<div class="bloque_compartir">';
            texto+=`<div class="cabecera_compartir"><div class="icono_cabecera_compartir"><img src="images/compartir_popup.svg" class="img_fluid"></div>${lang.comparte_tu_resultado}</div>`;
            texto+='<div class="links_compartir">';
                texto+='<ul>';
                    texto+='<li class="whatsapp">';
                        texto+='<div class="icono_compartir"><img src="images/whats.svg" class="img_fluid"></div>';
                        texto+='<div  class="texto_compartir">';
                            texto+=`<a href="whatsapp://send?text=${lang.texto_whatsapp} ${encodeURIComponent(url)}">`;
                                texto+=lang.por_whatsapp;
                                texto+='</a>';
                            texto+='</div>';
                    texto+='</li>';
                    texto+='<li class="copy">';
                        texto+='<div class="icono_compartir"><img src="images/copy.svg" class="img_fluid"></div>';
                            texto+='<div  class="texto_compartir">';
                                texto+=`<a href="javascript:void(0);" class="copia_link">`;
                                    texto+=lang.copiar_enlace;
                                texto+='</a>';
                        texto+='</div>';
                    texto+='</li>';
                    texto+='<li class="download">';
                        texto+='<div class="icono_compartir"><img src="images/download.svg" class="img_fluid"></div>';
                        texto+='<div  class="texto_compartir">';
                            texto+=`<a href="javascript:void(0);" class="descarga_imagen">`;
                            texto+=lang.descargar_imagen;
                            texto+='</a>';
                        texto+='</div>';
                    texto+='</li>';
                texto+='</ul>';
            texto+='</div>';
        texto+='</div>';
        muestraModalCompartir(texto) ;

        $('.copia_link').on('click',function(){
            copyToClipboard(url);
        })

        $('.descarga_imagen').on('click',function(){
            capturaPantalla();
        })

    })

    function modalFinal(){
        const url=generalUrl();
        let texto='<div class="bloque_registrar">';
            texto+=`<img src="./images/${$('#idioma').val()}.png" class="logo_home img_fluid margen_centrado">`;
            texto+='<div class="logo_texto_popup">';
                texto+='<img src="./images/imagen_popup.svg" class="img_regalo img_fluid margen_centrado">';
            texto+='</div>';
            texto+='<div  class="texto_compartir">';
            texto+=lang.mensaje_popup;
            texto+='</div>';
            texto+='<div  class="boton_popup">';
                texto+=`<a href="${lang.me_apunto_url}" target="_blank"  >`;
                texto+=lang.me_apunto;
                texto+='</a>';
            texto+='</div>';

        texto+='</div>';


        muestraModalCompartir(texto) ;
    }
});
